import React from 'react';

const SectionTitle = ({ 
  title, 
  subtitle, 
  alignment = 'center',
  titleColor = 'primary-blue',
  subtitleColor = 'gold',
  showLine = true,
  className = '' 
}) => {
  const alignments = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const titleColors = {
    'primary-blue': 'text-primary-blue',
    'white': 'text-white',
    'dark-gray': 'text-dark-gray'
  };

  return (
    <div className={`mb-12 ${alignments[alignment]} ${className}`}>
      {subtitle && (
        <span className={`text-${subtitleColor} font-semibold text-sm uppercase tracking-wider block mb-2`}>
          {subtitle}
        </span>
      )}
      <h2 className={`text-3xl md:text-4xl font-bold ${titleColors[titleColor]} mb-4`}>
        {title}
      </h2>
      {showLine && (
        <div className={`flex ${alignment === 'center' ? 'justify-center' : alignment === 'right' ? 'justify-end' : 'justify-start'}`}>
          <div className="w-24 h-1 bg-gold"></div>
        </div>
      )}
    </div>
  );
};

export default SectionTitle;